import { render, staticRenderFns } from "./Scans.vue?vue&type=template&id=a51c4924&scoped=true&"
import script from "./Scans.vue?vue&type=script&lang=js&"
export * from "./Scans.vue?vue&type=script&lang=js&"
import style0 from "./Scans.vue?vue&type=style&index=0&id=a51c4924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51c4924",
  null
  
)

export default component.exports